import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProductsService } from 'src/app/services/products.service';
import { MatSnackBar } from '@angular/material';
import { BasketsService } from 'src/app/services/baskets.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-create-basket',
  templateUrl: './create-basket.component.html',
  styleUrls: ['./create-basket.component.css']
})
export class CreateBasketComponent implements OnInit, OnDestroy {

  isLoading: boolean = false;
  isLoadingSub: Subscription;

  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  isLinear = false;

  productsFromAPI: any = [];
  productsToShow: any = [];
  products: any = [];
  productsToSubmit = [];

  public pictureURL: string = '';
  private picture: File;

  constructor(private _formBuilder: FormBuilder, private productsService: ProductsService, private basketsService: BasketsService, private snackBar: MatSnackBar) { }

  ngOnInit() {
    this.firstFormGroup = this._formBuilder.group({
      name: ['', Validators.required],
      price: ['', Validators.required],
      picture: ['', Validators.required],
      subscriptionPrice: ['', Validators.required],
      code: ['', Validators.required],
      description: ['', Validators.required],
    });

    this.secondFormGroup = this._formBuilder.group({
      quantity: ['', Validators.required]
    });

    this.productsService.getProductsAsAdminForBasket().subscribe(result => {
      this.productsFromAPI = result.data;
    });

    this.isLoadingSub = this.basketsService.getIsloadingUpdated().subscribe(result => {
      this.isLoading = result;
    })
  }

  onPictureSelected(event: Event) {
    const file = (event.target as HTMLInputElement).files[0];
    this.picture = file;

    this.pictureURL = URL.createObjectURL(file);
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (file) => {
      this.pictureURL = reader.result.toString();
    }
  }

  onAddProduct(ID, Name, Qty) {
    if (Qty === '') {
      this.snackBar.open('Quantity cannot be empty', 'Dismiss', {
        duration: 3000
      })
      return;
    } else if (Qty == 0) {
      this.snackBar.open('Quantity cannot be 0', 'Dismiss', {
        duration: 3000
      })
      return
    }

    const productToShow = {
      _id: ID,
      name: Name,
      quantity: Qty
    }

    this.productsToShow.push(productToShow);
  }

  onRemoveProduct(ID) {
    this.productsToShow = this.productsToShow.filter(product => product._id !== ID);
  }

  onAddBasket() {
    if (this.firstFormGroup.invalid) {
      this.snackBar.open('Please make sure all fields are filled', 'Dismiss', {
        duration: 3000
      })
      return
    } else if (this.productsToShow.length === 0) {
      this.snackBar.open('Products list is empty', 'Dismiss', {
        duration: 3000
      })
      return
    }

    this.productsToShow.map(product => {
      const updatedProduct = {
        _id: product._id,
        quantity: product.quantity
      }
      this.productsToSubmit.push(updatedProduct);
    });

    const data = new FormData();

    data.append('name', this.firstFormGroup.value.name);
    data.append('picture', this.picture);
    data.append('price', this.firstFormGroup.value.price);
    data.append('subscriptionPrice', this.firstFormGroup.value.subscriptionPrice);
    data.append('products', JSON.stringify(this.productsToSubmit));
    data.append('code', this.firstFormGroup.value.code);
    data.append('description', this.firstFormGroup.value.description);

    this.isLoading = true;
    this.basketsService.createBasket(data);
  }

  ngOnDestroy() {
    this.isLoadingSub.unsubscribe();
  }
}
